import { createPortal } from "react-dom";

import styles from "./GuestModal.module.css";
import GuestDropdownList from "./GuestDropdownList";
import { AttendeeType } from "../../../types/block/type";
import { PositionType } from "./GuestModal";

interface GuestInputWithDropdownProps {
  inputRef: React.RefObject<HTMLInputElement>;
  isInvalidEmail: boolean;
  handleGuestInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleGuestInputBlur: () => void;
  handleInputKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  filteredGuests: AttendeeType[];
  guestDropdownRef: React.RefObject<HTMLUListElement>;
  isScrolling: boolean;
  currentActiveIndex: number;
  handleAddGuest: (email: string) => void;
  guestDropdownPosition: PositionType | null;
  attendees: AttendeeType[];
}

const GuestInputWithDropdown = ({
  inputRef,
  isInvalidEmail,
  handleGuestInputChange,
  handleGuestInputBlur,
  handleInputKeyDown,
  filteredGuests,
  guestDropdownRef,
  isScrolling,
  currentActiveIndex,
  handleAddGuest,
  guestDropdownPosition,
  attendees,
}: GuestInputWithDropdownProps) => {
  return (
    <div className={styles.input_box}>
      <input
        ref={inputRef}
        className={`${styles["guests-input"]} ${isInvalidEmail && styles.validationError} `}
        placeholder="Add guests"
        onChange={handleGuestInputChange}
        onBlur={handleGuestInputBlur}
        onKeyDown={handleInputKeyDown}
      />
      {isInvalidEmail && <span className={styles.validationErrorIcon}></span>}

      {/* guests 후보 Dropdown */}
      {createPortal(
        inputRef.current?.value && filteredGuests.length > 0 && (
          <GuestDropdownList
            filteredGuests={filteredGuests}
            guestDropdownRef={guestDropdownRef}
            isScrolling={isScrolling}
            currentActiveIndex={currentActiveIndex}
            handleAddGuest={handleAddGuest}
            attendees={attendees}
            guestDropdownPosition={guestDropdownPosition}
          />
        ),
        document.body
      )}
    </div>
  );
};

export default GuestInputWithDropdown;
